// extracted by mini-css-extract-plugin
export default {"container":"wizard_container__liUoN","left":"wizard_left__vvau0","right":"wizard_right__8Z0Rv","closeButton":"wizard_closeButton__cCgv2"};